// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Clipboard from '@stimulus-components/clipboard'
application.register('clipboard', Clipboard)

import AccountsUserController from "./accounts_user_controller"
application.register("accounts-user", AccountsUserController)

import AudienceController from "./audience_controller"
application.register("audience", AudienceController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import ConfirmTypeController from "./confirm_type_controller"
application.register("confirm-type", ConfirmTypeController)

import DisableUploadsController from "./disable_uploads_controller"
application.register("disable-uploads", DisableUploadsController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EventsController from "./events_controller"
application.register("events", EventsController)

import IframeDialogController from "./iframe_dialog_controller"
application.register("iframe-dialog", IframeDialogController)

import JoinController from "./join_controller"
application.register("join", JoinController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import PreferencesController from "./preferences_controller"
application.register("preferences", PreferencesController)

import SchedulingsController from "./schedulings_controller"
application.register("schedulings", SchedulingsController)

import RevealMarketingController from "./reveal_marketing_controller"
application.register("reveal-marketing", RevealMarketingController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SendModalController from "./send_modal_controller"
application.register("send-modal", SendModalController)

import SettingsController from "./settings_controller"
application.register("settings", SettingsController)

import ScheduleSetupController from "./schedule_setup_controller"
application.register("schedule-setup", ScheduleSetupController)

import SetupController from "./setup_controller"
application.register("setup", SetupController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)


import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
